var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.775 0.380406C8.62448 0.191726 8.41706 0.0676213 8.18997 0.0305349C8.13953 0.0156186 8.08787 0.0062479 8.03571 0.00257725H0.964305C0.925776 -0.000859084 0.887105 -0.000859084 0.848576 0.00257725C0.613383 0.0335039 0.396851 0.157598 0.24038 0.351209C0.0838998 0.544809 -0.00170091 0.794326 2.56169e-05 1.05219V5.95039C2.56169e-05 6.2288 0.101619 6.49573 0.282423 6.69261C0.463298 6.88942 0.708526 7 0.964309 7H8.03572C8.2915 7 8.53672 6.88942 8.7176 6.69261C8.89841 6.49573 9 6.2288 9 5.95039V1.05219C8.99957 0.806501 8.91993 0.568777 8.775 0.380406ZM7.48929 0.702327L4.77644 3.39274L1.65217 0.702327H7.48929ZM8.35715 5.9504C8.35715 6.04317 8.32328 6.1322 8.26302 6.1978C8.20275 6.2634 8.12096 6.30027 8.03572 6.30027H0.964312C0.879077 6.30027 0.797284 6.2634 0.737017 6.1978C0.67675 6.1322 0.642885 6.04317 0.642885 5.9504V1.0522C0.642382 0.959187 0.67596 0.869844 0.736084 0.80377L4.4325 3.9806C4.53244 4.06901 4.65728 4.11727 4.78607 4.11711C4.92899 4.11664 5.0666 4.05799 5.17178 3.95264L8.29918 0.852782C8.33664 0.911277 8.35694 0.980859 8.35708 1.05224L8.35715 5.9504Z",
    fill: "#143232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownMessages);
export default __webpack_public_path__ + "static/media/dropdown-messages.f9202ee7b8669aad0fd707eeac1c0d58.svg";
export { ForwardRef as ReactComponent };